module.exports = __webpack_public_path__ + "img/top_phone.0655afb3.png";